document.addEventListener('DOMContentLoaded', function() {
    if (window.togglesInitialized) return;
    window.togglesInitialized = true;

    // ==========================================================================
    // STABILIZE PRIMARY SIDEBAR - Prevent jiggle/jump on page navigation
    // ==========================================================================
    const sidebar = document.querySelector('.bd-sidebar-primary');
    if (sidebar) {
        const initialScroll = sidebar.scrollTop;

        // Override scrollIntoView on sidebar nav items to prevent auto-scroll
        sidebar.querySelectorAll('.nav-link, .reference').forEach(link => {
            link.scrollIntoView = function(options) {
                // Do nothing - prevent theme from scrolling sidebar
            };
        });

        // Reset scroll position after theme JS runs
        setTimeout(() => {
            if (Math.abs(sidebar.scrollTop - initialScroll) > 50) {
                sidebar.scrollTop = initialScroll;
            }
        }, 100);
    }

    // ==========================================================================
    // SECONDARY SIDEBAR TOGGLE - Collapse/expand right sidebar (Endpoints TOC)
    // ==========================================================================
    const secondaryToggle = document.querySelector('button.sidebar-toggle.secondary-toggle');
    if (secondaryToggle) {
        // Restore collapsed state from localStorage
        const isCollapsed = localStorage.getItem('secondary-sidebar-collapsed') === 'true';
        if (isCollapsed) {
            document.body.classList.add('secondary-sidebar-collapsed');
        }

        secondaryToggle.addEventListener('click', function(e) {
            e.preventDefault();
            document.body.classList.toggle('secondary-sidebar-collapsed');

            // Save preference to localStorage
            const nowCollapsed = document.body.classList.contains('secondary-sidebar-collapsed');
            localStorage.setItem('secondary-sidebar-collapsed', nowCollapsed);
        });
    }

    // ==========================================================================
    // CHILD PROPERTY TOGGLE - Show/hide nested parameters
    // ==========================================================================
    const toggles = document.querySelectorAll('.parameters-child-toggle');

    toggles.forEach((toggle) => {
        let parameterContainer = toggle.closest('.parameter-item');
        if (!parameterContainer) {
            parameterContainer = toggle.parentElement;
        }
        if (!parameterContainer) return;

        const content = parameterContainer.querySelector('.parameters-child-content');
        const toggleIcon = toggle.querySelector('.toggle-icon');
        const toggleText = toggle.querySelector('span:not(.toggle-icon)');

        if (content) {
            // Remove inline display:none so CSS can control visibility
            content.style.display = '';
            content.style.removeProperty('display');

            // Start collapsed
            content.classList.add('collapsed');

            if (toggleIcon) toggleIcon.textContent = '▶';
            if (toggleText) toggleText.textContent = 'Show child properties';

            toggle.style.cursor = 'pointer';

            toggle.addEventListener('click', function(event) {
                event.preventDefault();
                event.stopPropagation();

                const isCollapsed = content.classList.toggle('collapsed');
                if (toggleIcon) toggleIcon.textContent = isCollapsed ? '▶' : '▼';
                if (toggleText) toggleText.textContent = isCollapsed ? 'Show child properties' : 'Hide child properties';
            });
        }
    });

    // ==========================================================================
    // SIDEBAR TOGGLE - Wide screen visibility
    // ==========================================================================
    const sidebarButton = document.querySelector('.sidebar-toggle.primary-toggle');
    const sidebarCheckbox = document.getElementById('pst-primary-sidebar-checkbox');
    if (sidebarButton && sidebarCheckbox) {
        sidebarButton.addEventListener('click', function() {
            if (window.matchMedia('(min-width: 992px)').matches) {
                sidebarCheckbox.checked = !sidebarCheckbox.checked;
            }
        });
    }
});
